import { useGetSJTPPGDaljab } from 'api/useAPIPPGDaljab'
import Head from 'next/head'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'

import type { TopicProgressState } from 'utils/helper'
import { determineTopicState, shouldHideNav } from 'utils/helper'
import useTopicDetails from 'utils/hooks/useTopicDetails'

import ProgressionBar from 'components/Topic/ProgressionBar'
import TopicHeader from 'components/Topic/TopicHeader'

import NeedRevision from './components/NeedRevision'
import RefleksiCard from './components/RefleksiCard'
import SJTContent from './components/SJTContent'
import TopicContent from './components/TopicContent'

const TopicDetails = () => {
  const { query } = useRouter()
  const { topik } = query
  const getTopicDetails = useTopicDetails(topik as string)
  const [isAksiNyataLocked, setIsAksiNyataLocked] = useState(true)
  const getStjPPGDaljab = useGetSJTPPGDaljab(topik as string)

  // Determine if aksinyata is locked or not
  useEffect(() => {
    if (getTopicDetails?.fetchStatus === 'success') {
      const topicState = determineTopicState(
        getTopicDetails?.progressionData,
        true
      )

      const optNotLocked: TopicProgressState[] = [
        'MODULE_DONE',
        'AKSI_NYATA_CREATED',
        'AKSI_NYATA_ON_PROGRESS',
        'AKSI_NYATA_DONE',
        'AKSI_NYATA_NEED_REVISION',
        'AKSI_NYATA_VALIDATED',
        'AKSI_NYATA_APPEAL',
      ]
      if (optNotLocked.includes(topicState)) {
        setIsAksiNyataLocked(false)
      }
    }
  }, [
    getTopicDetails?.progressionData,
    getTopicDetails?.fetchStatus,
    getTopicDetails?.topicData?.name,
  ])

  const isStjNotDone = getStjPPGDaljab?.data?.data?.some(
    (item) => !item.is_done
  )

  const isRefleksiLocked = isAksiNyataLocked || isStjNotDone
  const isNeedRevision =
    getTopicDetails?.progressionData?.aksiNyata?.state === 'NEED_REVISION'

  return (
    <>
      <Head>
        <title>
          Sertifikasi Pendidik | Topik {getTopicDetails?.topicData?.name}
        </title>
      </Head>
      <div
        className="relative pb-6 bg-gray-10 z-0"
        style={{
          minHeight: shouldHideNav() ? '100vh' : 'calc(100vh - 3.5rem)',
        }}
      >
        {!shouldHideNav() && (
          <div className="sticky top-[54px] z-30">
            <TopicHeader
              title={getTopicDetails?.topicData?.name}
              shouldShowTab={Boolean(
                getTopicDetails?.topicData?.contextualizedPageId
              )}
            />

            <div className="hidden">
              <div className="sticky top-[54px] z-10 px-8 py-3 h-24 -mx-3 bg-gray-5">
                <ProgressionBar
                  progressData={getTopicDetails?.progressionData}
                />
              </div>
              <div className="relative mb-4 -mx-3">
                <hr className="border-subdued" />
              </div>
            </div>
          </div>
        )}
        <div className="mb-6">
          <TopicContent data={getTopicDetails} />
        </div>
        <div>
          <SJTContent data={getStjPPGDaljab} isLocked={isAksiNyataLocked} />
        </div>
        {getTopicDetails?.fetchStatus === 'success' && (
          <div className="relative px-3 z-0">
            <RefleksiCard
              topikId={query.topik as string}
              name={getTopicDetails?.topicData?.name}
              selectedOptionTitle={
                getTopicDetails?.progressionData?.aksiNyata?.selectedOption
                  ?.title
              }
              optionsAmount={
                getTopicDetails?.topicData?.aksiNyataOptionCount || 0
              }
              aksiNyataSessionState={
                getTopicDetails?.progressionData?.aksiNyata?.state
              }
              isLocked={isRefleksiLocked}
              aksiNyataId={getTopicDetails?.progressionData?.aksiNyata?.id}
            />
            {isNeedRevision && (
              <NeedRevision
                revision={getTopicDetails?.revisionItems?.[0] || ''}
                name={getTopicDetails?.topicData?.name}
                topikId={query.topik as string}
              />
            )}
          </div>
        )}
      </div>
    </>
  )
}

export default TopicDetails
